module.exports = __webpack_public_path__ + "img/9788983945891.2be865ce.jpg";